import React from 'react';

const NewBadge: React.FC = () => {
  return (
    <svg
      width="32"
      height="41"
      viewBox="0 0 32 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_370_5623)">
        <mask
          id="mask0_370_5623"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="-1"
          y="0"
          width="33"
          height="41"
        >
          <path d="M31.0711 0H-0.000488281V41H31.0711V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_370_5623)">
          <path
            d="M-0.000488281 0H15.5354H31.0709V15.5358V28.8237C31.0709 30.2241 30.3571 31.5278 29.1772 32.282L17.7454 39.5875C16.3976 40.4488 14.6728 40.4488 13.3255 39.5875L1.89363 32.282C0.713775 31.5278 -0.000488281 30.2241 -0.000488281 28.8237V15.5358V0Z"
            fill="#B6F828"
          />
          <path
            d="M23.4094 17.415C23.8282 17.415 24.1686 17.478 24.4299 17.604C24.6918 17.73 24.8964 17.9074 25.0435 18.1361C25.1909 18.3649 25.2908 18.642 25.343 18.9677C25.3956 19.2934 25.4215 19.6539 25.4215 20.0494V23.5851H23.9444V20.1424C23.9444 19.9137 23.933 19.7014 23.9094 19.5056C23.8863 19.3098 23.8377 19.1412 23.7642 18.9997C23.6907 18.8582 23.5877 18.7477 23.4561 18.6682C23.324 18.5888 23.1498 18.549 22.9324 18.549H21.537V23.5851H20.0713V17.415H23.4094Z"
            fill="#2C2C2C"
          />
          <path
            d="M16.4892 23.5851V18.549H13.6167V17.415H18.6701V18.549H17.9899V23.5851H16.4892Z"
            fill="#2C2C2C"
          />
          <path
            d="M12.6568 17.415V20.3925C12.6568 21.4586 12.3982 22.2572 11.8808 22.7884C11.3631 23.3195 10.6198 23.5851 9.65047 23.5851H6.22527L5.64941 17.415H7.05116L7.57438 22.4511H9.10365C9.41768 22.4511 9.70855 22.4327 9.97629 22.3958C10.2436 22.359 10.4741 22.2786 10.6683 22.1545C10.8621 22.0304 11.0132 21.8502 11.1217 21.6137C11.2301 21.3772 11.2846 21.0612 11.2846 20.6658V17.415H12.6568ZM9.95269 21.1659H8.56864V17.415H9.95269V21.1659Z"
            fill="#2C2C2C"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_370_5623">
          <rect width="31.0716" height="41" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NewBadge;
